<template>
  <!-- 遮罩层 -->
  <div class="date-mask" v-show="visible" @click="handleMaskClose">
    <!-- 底部抽屉容器 -->
    <div class="date-drawer" :class="{ show: visible }">
      <!-- 头部：标题 + 取消按钮 -->
      <div class="date-drawer-header">
        <span class="cancel-btn" @click="handleCancel">取消</span>
        <span class="title_date">选择购买日期</span>
        <span class="confirm-btn" @click="handleConfirm">确认</span>
      </div>

      <!-- 日期选择区域 -->
      <div class="date-select-wrapper">
        <!-- 年选择 -->
        <select v-model="selectedYear" class="date-select">
          <option v-for="year in yearList" :key="year" :value="year">{{ year }}年</option>
        </select>
        <!-- 月选择 -->
        <select v-model="selectedMonth" class="date-select">
          <option v-for="month in monthList" :key="month" :value="month">{{ month }}月</option>
        </select>
        <!-- 日选择 -->
        <select v-model="selectedDay" class="date-select">
          <option v-for="day in dayList" :key="day" :value="day">{{ day }}日</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatePickerDrawer',
  props: {
    // 是否显示弹框
    visible: {
      type: Boolean,
      default: false
    },
    // 初始日期（回显用，格式：yyyy-MM-dd）
    initDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 选中的年/月/日
      selectedYear: '',
      selectedMonth: '',
      selectedDay: '',
      // 年份列表（近20年）
      yearList: [],
      // 月份列表
      monthList: Array.from({ length: 12 }, (_, i) => i + 1),
      // 日期列表（根据年月动态生成）
      dayList: []
    }
  },
  watch: {
    // 监听初始日期变化，初始化选中值
    initDate: {
      immediate: true,
      handler(val) {
        this.initSelectedDate(val)
      }
    },
    // 监听年月变化，更新日期列表
    selectedYear() {
      this.updateDayList()
    },
    selectedMonth() {
      this.updateDayList()
    }
  },
  created() {
    // 生成年份列表（当前年 ±10 年）
    const currentYear = new Date().getFullYear()
    this.yearList = Array.from({ length: 20 }, (_, i) => currentYear - 10 + i)
    // 初始化日期列表
    this.updateDayList()
  },
  methods: {
    // 初始化选中的日期
    initSelectedDate(initDate) {
      if (!initDate) {
        // 无初始日期，默认选中今天
        const now = new Date()
        this.selectedYear = now.getFullYear()
        this.selectedMonth = now.getMonth() + 1
        this.selectedDay = now.getDate()
        return
      }
      // 解析初始日期
      const [year, month, day] = initDate.split('-').map(Number)
      this.selectedYear = year
      this.selectedMonth = month
      this.selectedDay = day
    },
    // 根据年月更新日期列表
    updateDayList() {
      if (!this.selectedYear || !this.selectedMonth) return
      // 获取当月最后一天
      const lastDay = new Date(this.selectedYear, this.selectedMonth, 0).getDate()
      this.dayList = Array.from({ length: lastDay }, (_, i) => i + 1)
      // 若当前选中的日超过当月最大日，重置为最后一天
      if (this.selectedDay > lastDay) {
        this.selectedDay = lastDay
      }
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate() {
      const month = this.selectedMonth.toString().padStart(2, '0')
      const day = this.selectedDay.toString().padStart(2, '0')
      return `${this.selectedYear}-${month}-${day}`
    },
    // 确认选择
    handleConfirm() {
      const formattedDate = this.formatDate()
      // 向父组件传递选中的日期
      this.$emit('confirm', formattedDate)
      // 关闭弹框
      this.$emit('close')
    },
    // 取消选择
    handleCancel() {
      this.$emit('close')
    },
    // 点击遮罩关闭（阻止冒泡）
    handleMaskClose(e) {
      if (e.target.classList.contains('date-mask')) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
/* 遮罩层 */
.date-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

/* 底部抽屉容器 */
.date-drawer {
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  transform: translateY(100%);
  transition: transform 0.3s ease;
  z-index: 9999;
}

/* 抽屉显示动画 */
.date-drawer.show {
  transform: translateY(0);
}

/* 抽屉头部 */
.date-drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f5f5f5;
}

.cancel-btn, .confirm-btn {
  font-size: 16px;
  color: #409eff;
  cursor: pointer;
  /* 扩大触控区域，适配平板点击 */
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

/* 按钮hover效果，平板端也友好 */
.cancel-btn:hover, .confirm-btn:hover {
  background-color: #ecf5ff;
}

.confirm-btn {
  font-weight: 600;
}

.title_date {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 日期选择区域 */
.date-select-wrapper {
  display: flex;
  justify-content: space-around;
  padding: 20px 10px;
  /* 平板端增加上下内边距 */
  gap: 12px;
}

.date-select {
  width: 30%;
  height: 45px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 16px;
  color: #333;
  outline: none;
  appearance: none; /* 去掉原生下拉箭头 */
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E") no-repeat right 10px center;
  background-size: 16px;
  /* 优化触控体验 */
  touch-action: manipulation;
}

/* 移动端适配（手机） */
@media screen and (max-width: 768px) {
  .date-select {
    height: 50px;
    font-size: 18px;
  }
  .date-drawer {
    padding-bottom: 50px;
  }
  .date-drawer-header {
    padding: 20px;
  }
  .title_date {
    font-size: 20px;
  }
  .cancel-btn, .confirm-btn {
    font-size: 18px;
    padding: 10px 15px;
  }
}

/* 平板适配（768px - 1200px） */
@media screen and (min-width: 768px) and (max-width: 1200px) {
  /* 抽屉整体优化 */
  .date-drawer {
    margin: 0 auto;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  /* 头部样式优化 */
  .date-drawer-header {
    padding: 20px 30px;
    border-bottom: 2px solid #f0f0f0;
  }
  .title_date {
    font-size: 22px;
    color: #222;
  }
  .cancel-btn, .confirm-btn {
    font-size: 20px;
    padding: 12px 18px;
  }
  /* 选择框优化 */
  .date-select-wrapper {
    padding: 30px 20px;
    gap: 15px;
  }
  .date-select {
    height: 60px;
    font-size: 20px;
    border-radius: 12px;
    padding: 0 15px;
    background-position: right 15px center;
    background-size: 20px;
    border-width: 2px;
  }
}

/* 大屏平板/小电脑适配（1200px以上） */
@media screen and (min-width: 1200px) {
  .date-drawer {
    max-width: 60%;
    margin: 0 auto;
  }
  .date-select {
    height: 55px;
    font-size: 18px;
  }
}
</style>